import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as routeLink from "../../constants/routeLink";
import { formatNumber } from '../../services/services';
const Index = (props) => {
  const dispatch = useDispatch()
  const { appReducer } = useSelector(state => state);

  return (

    <div className='card-custom card-custom-task w-100 p-3 radius-custom justify-content-center align-items-center mt-2' onClick={() => { props?.actions() }}>

      <div className='card-img'>
        <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/btntouch.png`} />
      </div>
      <div className='d-flex justify-content-center align-items-start flex-column'>
        <span className='text-white fw-bold mb-2'>{props?.item?.userName}</span>
        <div className='d-flex w-100'>
          <div className='card-icon me-2  d-flex align-items-center justify-content-center'>
            <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>
          <span className='fw-bold color-sub-pri'>{formatNumber(props?.item?.balanceTon)}</span>
        </div>
      </div>

      <div className='d-flex justify-content-center align-items-end flex-column'>
        <span className='fw-bold fs-extra text-white'>{(props?.key_ || 0) + 1}</span>

      </div>
    </div>

  )
}

export default Index;
